import { createContext, useContext, useEffect, useRef, useState } from "react";
import stompClient from "./stompClient";
import TypeMessagesRMQ from "../constants/TypeMessagesRMQ";

const WebSocketContext = createContext(null);

export const WebSocketProvider = ({ children }) => {
  const [entriesMessageRMQ, setEntriesMessageRMQ] = useState([]);
  const [raceCreateMessageRMQ, setRaceCreateMessageRMQ] = useState([]);
  const [entryCreateMessageRMQ, setEntryCreateMessageRMQ] = useState([]);
  const [poolMessageRMQ, setPoolMessageRMQ] = useState([]);
  const [resultCreateMessageRMQ, setResultCreateMessageRMQ] = useState([]);
  const [raceChangesMessageRMQ, setRaceChangesMessageRMQ] = useState([]);
  const [packagesMessageRMQ, setPackagesMessageRMQ] = useState([]);
  const [raceChangesMessageTrackList, setRaceChangesMessageTrackList] =
    useState([]);
  let tracksInfo = JSON.parse(localStorage.getItem("TracksInfo")) || {
    thoroughbredList: [],
    harnessList: [],
    greyList: [],
    trackList: [],
    specialEventsList: [],
  };
  const [stateTracks, setStateTracks] = useState(tracksInfo);
  const [callGetActiveTracks, setCallGetActiveTracks] = useState(false);
  const [selectOption, setSelectOption] = useState({
    trackID: 0,
    trackName: "",
    raceID: 0,
    raceNumber: 0,
    trackCode: "",
    status: "",
    raceStatus: "",
  });

  const selectOptionRef = useRef(selectOption);

  useEffect(() => {
    selectOptionRef.current = selectOption;
  }, [selectOption]);

  const setOptions = (
    track,
    trackName,
    race,
    raceNumber,
    trackCode,
    status,
    raceStatus,
  ) => {
    setSelectOption({
      trackID: track,
      trackName: trackName,
      raceID: race,
      raceNumber: raceNumber,
      trackCode: trackCode,
      status: status,
      raceStatus: raceStatus,
    });
  };

  useEffect(() => {
    stompClient.onConnect = () => {
      stompClient.subscribe(
        `/exchange/${window.config.RMQConfig.Exchange}`,
        (message) => {
          const obj = JSON.parse(message.body);

          if (obj.MessageType === TypeMessagesRMQ.EntryChange.name) {
            if (
              selectOptionRef.current.raceID &&
              selectOptionRef.current.raceID === obj.RaceID
            ) {
              setEntriesMessageRMQ((prevState) => [obj, ...prevState]);
            }
          } else if (obj.MessageType === TypeMessagesRMQ.RaceCreate.name) {
            const trackExists = stateTracks.trackList.some(
              (track) => track.TrackID === obj.TrackID,
            );

            if (!trackExists) {
              setCallGetActiveTracks(true);
              return;
            }
            if (
              selectOptionRef.current.trackID &&
              selectOptionRef.current.trackID === obj.TrackID
            ) {
              setRaceCreateMessageRMQ((prevState) => [obj, ...prevState]);
            }
          } else if (obj.MessageType === TypeMessagesRMQ.EntryCreate.name) {
            if (
              selectOptionRef.current.raceID &&
              selectOptionRef.current.raceID === obj.RaceID
            ) {
              setEntryCreateMessageRMQ((prevState) => [obj, ...prevState]);
            }
          } else if (obj.MessageType === TypeMessagesRMQ.Pool.name) {
            if (
              selectOptionRef.current.raceID &&
              selectOptionRef.current.raceID === obj.RaceID
            ) {
              setPoolMessageRMQ((prevState) => [obj, ...prevState]);
            }
          } else if (obj.MessageType === TypeMessagesRMQ.ResultCreate.name) {
            if (
              selectOptionRef.current.raceID &&
              selectOptionRef.current.raceID === obj.RaceID
            ) {
              setResultCreateMessageRMQ((prevState) => [obj, ...prevState]);
            }
          } else if (obj.MessageType === TypeMessagesRMQ.RaceChange.name) {
            setRaceChangesMessageRMQ((prevState) => [obj, ...prevState]);
            setRaceChangesMessageTrackList((prevState) => [obj, ...prevState]);
          } else if (obj.MessageType === TypeMessagesRMQ.Packages.name) {
            setPackagesMessageRMQ((prevState) => [obj, ...prevState]);
          }
        },
      );
    };

    stompClient.activate();

    return () => {
      stompClient.deactivate();
    };
  }, []);

  return (
    <WebSocketContext.Provider
      value={{
        entriesMessageRMQ,
        setEntriesMessageRMQ,
        raceCreateMessageRMQ,
        setRaceCreateMessageRMQ,
        entryCreateMessageRMQ,
        setEntryCreateMessageRMQ,
        poolMessageRMQ,
        setPoolMessageRMQ,
        resultCreateMessageRMQ,
        setResultCreateMessageRMQ,
        raceChangesMessageRMQ,
        setRaceChangesMessageRMQ,
        raceChangesMessageTrackList,
        setRaceChangesMessageTrackList,
        selectOption,
        setOptions,
        stateTracks,
        setStateTracks,
        callGetActiveTracks,
        setCallGetActiveTracks,
        packagesMessageRMQ,
        setPackagesMessageRMQ,
      }}
    >
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => {
  const context = useContext(WebSocketContext);
  if (!context) {
    console.warn("useWebSocket must be used within a WebSocketProvider");
    return {
      lastMessage: { MessageType: "", Message: "No provider detected" },
    };
  }
  return context;
};
